import React from "react";
import { ConstantInfo } from "../../../core/constantInfo";

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="flex flex-col">
      <div className="max-w-screen-2xl w-full place-self-center py-10">
        
        <section className="mb-12">
          <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
          <div className="text-lg mb-4 leading-relaxed">
            <p><strong>Effective Date:</strong> 20 Jun 2025</p>
            <p><strong>Website:</strong> https://www.dme-tech.com</p>
            <p><strong>Company:</strong> DME Tech LLC, 1007 N Orange St, Wilmington, DE 19801, USA</p>
          </div>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">1. What We Collect</h2>
          <p className="text-lg mb-4">
            We collect basic personal information you provide (such as name, email, country) and technical data related to file uploads and platform usage.
          </p>
          <p className="text-lg">
            We do not collect sensitive payment data — all transactions are processed via third-party providers (e.g. PayPal, Stripe, Telegram Wallet).
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">2. How We Use Data</h2>
          <p className="text-lg mb-4">
            We use your data to:
          </p>
          <ul className="space-y-3 ml-5">
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">Provide services and respond to support inquiries</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">Analyze usage patterns for product improvement</span>
            </li>
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              <span className="text-lg">Communicate important updates and service-related information</span>
            </li>
          </ul>
          <p className="text-lg mt-4 font-medium">
            We do <strong>not</strong> sell or share your personal data with third parties.
          </p>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">3. Data Storage and Protection</h2>
          <p className="text-lg mb-4">
            All user data is stored securely using industry-standard encryption and access controls.
          </p>
          <p className="text-lg">
            We retain user data only as long as necessary to provide services and comply with legal obligations.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">4. Cookies</h2>
          <p className="text-lg">
            Our website may use cookies to improve user experience. You may disable cookies in your browser settings.
          </p>
        </section>

        <section className="mb-12 bg-content4 bg-opacity-50 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">5. Third-Party Services</h2>
          <p className="text-lg">
            We use third-party platforms to process payments and collect usage analytics. Each provider operates under its own privacy policy.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
          <p className="text-lg">
            You may request to view, update, or delete your personal data at any time by contacting us.
          </p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;